import createOpenGraphTags from '@repo/utils/createOpenGraphTags';

function generateHeadTagData(
  SEOMetadata,
  product,
  description,
  productSchema,
  selectedVariant,
  location,
  store
) {
  return {
    title: SEOMetadata?.title || product?.title,
    description: SEOMetadata?.description || description,
    canonicalUrl: SEOMetadata?.canonicalUrl,
    noIndex: SEOMetadata?.noIndex,
    noFollow: SEOMetadata?.noFollow,
    schemaOrgObj: productSchema,
    meta: createOpenGraphTags(
      {
        title: SEOMetadata?.ogTitle || SEOMetadata?.title || product?.title,
        description:
          SEOMetadata?.ogDescription ||
          SEOMetadata?.description ||
          description ||
          product?.description,
        url:
          SEOMetadata?.ogUrl || SEOMetadata?.canonicalUrl || location.pathname,
        type: 'product',
        'og:price:currency': 'USD',
        'og:price:amount': selectedVariant?.price,
        image: SEOMetadata?.ogImage || store?.previewImageUrl,
      },
      'invisiblefence'
    ),
  };
}

export default generateHeadTagData;
